import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getClosedOrders } from '../actions/index';
import _ from 'lodash';
import moment from 'moment';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';
import PosLeftNav from './pos_left_nav';
import PosSearchNav from './pos_search_nav';
import ClosedOrdersItems from './closed_orders_items';

class ClosedOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: 'today',    // What section of items are we viewing (today, yesterday, older)
      itemsPerLoad: 20, // How many items to grab at a time
      itemsShown: 0,    // How many items total are being shown
      closedOrders: '', // All the closed orders from the orders reducer
      serverPage: 1,    // What page of results we want from the server for 'Older' orders
    }
  }

  componentWillMount() {
    // Before the component loads, start fetching the first page of closed orders
    this.gatherClosedOrders(this.props.orders);
  }

  componentWillReceiveProps(nextProps) {
    // Update closedOrders state when the order reducers changes
    this.gatherClosedOrders(nextProps.orders);
  }

  // Take the orders reducer and grab any closed orders and keep it in
  // local component state
  gatherClosedOrders = orders => {
    orders = Object.values(orders);

    // Grab orders from the orders reducer which are 'CLOSED'
    let closedOrders = orders.filter(function(order) {
      return order.order_status === 'CLOSED';
    });

    // Show newest orders first
    closedOrders = _.orderBy(closedOrders, ['order_time_start'], ['desc']);

    // Grab only the ones with the current data we are looking at
    closedOrders = this.filterClosedOrdersByDate(closedOrders, this.state.date);

    // Is this our initial load? (or less orders than itemsPerLoad)
    if (this.state.itemsShown < this.state.itemsPerLoad) {
      // If we have more to load, start with only itemsPerLoad
      if (closedOrders.length > this.state.itemsPerLoad) {
        this.setState({ itemsShown: this.state.itemsPerLoad });
      // We have less orders than itemsPerLoad
      } else {
        this.setState({ itemsShown: closedOrders.length });
      }
    }

    this.setState({ closedOrders: closedOrders });
  }

  // Take the closedOrders state and filter through them by the date period selected
  filterClosedOrdersByDate(closedOrders, date = 'today') {
    // Otherwise, filter orders by today and yesterday (which are stored locally)
    let TODAY = moment().startOf('day');
    let YESTERDAY = moment().subtract(1, 'days').startOf('day');
    let OLDER = moment().subtract(1, 'days').endOf('day');

    closedOrders = closedOrders.filter(function(order) {
      if (date === 'today') {
        return moment(order.order_time_start).isSame(TODAY, 'd');
      } else if (date === 'yesterday') {
        return moment(order.order_time_start).isSame(YESTERDAY, 'd')
      }
      return moment(order.order_time_start).isBefore(OLDER, 'd')
    });

    return closedOrders;
  }

  // When the user clicks on the date menu
  handleDate(date) {
    this.setState({ date: date }, function() {
      this.gatherClosedOrders(this.props.orders);
    });

    // Any time they click on 'Older', grab first page of orders
    if (date === 'older' ) {
      this.props.getClosedOrders(1, 'older');
    }
  }

  // When the user clicks on the Load More Items button
  handleLoadMore() {
    if (this.state.date === 'older') {
      this.setState({ serverPage: (this.state.serverPage + 1)}, function() {
        this.props.getClosedOrders(this.state.serverPage, 'older');
      });
    }

    this.setState({ itemsShown: (this.state.itemsShown + this.state.itemsPerLoad)});
  }

  // Decide if to show the Load More Items button
  renderLoadMore() {
    if ((this.state.date === 'older') || (this.state.closedOrders.length > this.state.itemsShown)) {
      return (
        <div>
          <br />
          <button type="button" onClick={event => this.handleLoadMore()} className="btn btn-primary btn-block waves-effect waves-light">Load More Items</button>
        </div>
      );
    }
  }

  render() {
    return(
      <div>
        <Overlay />
        <Sidebar />
        <Header />
        <div className="site-content">
          <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
            <div className="container pl-0 pr-0">
              <div className="row">
                <PosLeftNav />
                <PosSearchNav orderType="closed" date={this.state.date} />
              </div>
            </div>            
          </nav>
          <div className="box box-block">
            <div className="btn-group btn-group-lg">
              <button type="button" onClick={event => this.handleDate('today')} className={ 'btn btn-' + (this.state.date === 'today' ? 'primary' : 'secondary') + ' waves-effect waves-light'}>Today</button>
              <button type="button" onClick={event => this.handleDate('yesterday')} className={ 'btn btn-' + (this.state.date === 'yesterday' ? 'primary' : 'secondary') + ' waves-effect waves-light'}>Yesterday</button>
              <button type="button" onClick={event => this.handleDate('older')} className={ 'btn btn-' + (this.state.date === 'older' ? 'primary' : 'secondary') + ' waves-effect waves-light'}>Older</button>
            </div>
            <br /><br />
            <div className="table-responsive">
              <ClosedOrdersItems closedOrders={this.state.closedOrders.slice(0, this.state.itemsShown)} />
            </div>
            {this.renderLoadMore()}
            <br />
          </div>
        </div>
    </div>
    );
  }
}

function mapStateToProps({ orders }) {
  return { orders };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { getClosedOrders }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ClosedOrders);



// WEBPACK FOOTER //
// ./src/containers/closed_orders.js